<template>
  <!-- Service Section -->
  <section class="car-blogs-section">
    <div class="container">
      <div class="row">
					<div class="col-md-12 text-center">
						<div class="section-heading car-wash-heading aos" data-aos="fade-up">
							<div class="car-wash-img-five">
								<img src="@/assets/img/icons/car-wash-header-1.svg" alt="image"
									class="car-wash-header-one">
								<h2>Our Blogs</h2>
								<img src="@/assets/img/icons/car-wash-header-2.svg" alt="image"
									class="car-wash-header-two">
							</div>
							<p>Here’s a compelling blog description designed to attract readers and provide a clear idea
								of what they can expect from your blog</p>
						</div>
					</div>
				</div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel car-blog-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexfiveservice" :key="item.id">
                <div class="service-widget aos" data-aos="fade-up">
                  <div class="service-img">
                    <router-link to="/details/service-details">
                      <img class="img-fluid serv-img" alt="Service Image"
                        :src="require(`@/assets/img/car-wash/${item.image}`)">
                    </router-link>
                    <div class="fav-item">
                      <div class="fav-items-content">
                        <h4 class="item-cat item-car fs-24">25 </h4>
                        <span class="text-dark fs-14"> Dec</span>
                      </div>
                    </div>
                    <div class="fav-items-container">
                      <div class="card mb-0">
                        <div class="card-header border-0 pb-0">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class=" d-flex align-items-center">
                              <div class="avatar-sm avatar me-2"><img
                                :src="require(`@/assets/img/profiles/${item.avatar}`)" alt="img"
                                class="img-fluid rounded-circle ">
                            </div>
                            <p class="fs-14 text-white">{{item.name}}</p>
                            </div>
                            <div>
                              <p class="fs-14 text-white">{{item.badge}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="card-body text-start">
                          <h5 class="text-white"><router-link to="/blogs/blog-details">{{item.Title}}</router-link></h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Service Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexfiveservice from "@/assets/json/indexfiveservice.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexfiveservice: indexfiveservice,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
